import React, {useState} from 'react';
import {t} from 'i18next';
import {Box, Stack, Typography} from '@mui/material';
import {Query} from '../../../types/Query';
import ArrSlider from '../../../../../../src/components/common/arr-slider/ArrSlider';
import {Criteria} from '../../../types/Criteria';

import ChipPanel from '../query-panel/chip-panel/ChipPanel';

const DEFAULT_SCORE = 70;

export interface ConceptualProps {
  query: Query;
  onTextChanged?: (query: Query) => void;
  userRoleId: number;
}
const Conceptual: React.FC<ConceptualProps> = ({
  query,
  onTextChanged,
  userRoleId,
}) => {
  const [sliderValue, setSliderValue] = useState(DEFAULT_SCORE);

  /*Allowed roles : ProjectAdministrator / ReviewManager /  Reviewer */
  const ALLOWED_ROLES = [1, 2, 3];

  const isAllowed = ALLOWED_ROLES.includes(userRoleId);
  if (!isAllowed) return null;

  const handleCriteriaChanged = (updatedCriteria: Criteria[]) => {
    const criteriaWithScore = updatedCriteria.map((criteria) => ({
      ...criteria,
      conceptScore: sliderValue,
    }));

    onTextChanged?.({...query, value: [...criteriaWithScore]});
  };

  const handleSliderChanged = (val: number) => {
    setSliderValue(val);

    const updatedCriteria = (query.value ?? []).map((criteria) => ({
      ...criteria,
      conceptScore: val,
    }));

    onTextChanged?.({...query, value: updatedCriteria});
  };

  return (
    <Stack
      spacing={1}
      className="conceptual-content-panel"
      data-testid="conceptual-content-panel"
    >
      <Stack direction="row" className="query-actions" flexWrap="wrap">
        <Typography
          className="precision-sensitivity-typo typo-text label3_size"
          data-testid={`conceptual-precision-sensitivity`}
        >
          {t('sessionSearch.queryList.conceptual.precisionSensitivity')}
        </Typography>

        <ArrSlider
          value={sliderValue}
          onChange={handleSliderChanged}
          min={0}
          max={100}
          step={1}
          ariaLabel="ConceptualSlider"
          label=""
          showInput
          dataTestId="conceptual-slider"
        />
      </Stack>
      <Box
        className="query-chips"
        data-testid="chip-panel-conceptual-criteria-wrapper"
      >
        <ChipPanel
          criteria={query.value}
          onCriteriaChange={handleCriteriaChanged}
          dataTestId="conceptual-panel"
        />
      </Box>
    </Stack>
  );
};

export default Conceptual;
